import { FC } from 'react';

import { ContentfulCollectionName } from '@ravago/shared/page-data/models/contentful';
import { Alert } from '@ravago/shared/radiance/components/alert/components/Alert/Alert';

type DynamicNodePlaceholderProps = {
   contentType?: ContentfulCollectionName;
   supportedContentTypes: ContentfulCollectionName[];
};

export const DynamicNodePlaceholder: FC<DynamicNodePlaceholderProps> = ({ contentType, supportedContentTypes }) => {
   const isSupported = contentType && supportedContentTypes.includes(contentType);

   return (
      <div style={{ textAlign: 'center' }}>
         {!isSupported && (
            <Alert variant="warning">
               {contentType && (
                  <>
                     This dynamic block is not supported for content type: <b>{contentType}.</b>
                  </>
               )}
               {!contentType && (
                  <>
                     Value <b>Dynamic</b> cannot be used on regular pages.
                  </>
               )}
            </Alert>
         )}

         {isSupported && (
            <Alert variant="warning">
               <>
                  You are trying to render a dynamic block but no preview content was set.
                  <br />
                  Please select a <b>preview</b> option in the top right corner.
               </>
            </Alert>
         )}
      </div>
   );
};
